export function genId() {
    return `${Math.random() * 100000000000000000}`;
}
